import { useTheme } from '@emotion/react';
import { isNil } from 'ramda';

import * as styles from './code-pin-placeholder.styles';

type Props = {
  value?: string;
  showValue?: boolean;
  readOnly?: boolean;
  current?: boolean;
};

export const CodePinPlaceholder = ({
  value,
  showValue = false,
  readOnly = false,
  current = false,
  ...props
}: Props) => {
  const theme = useTheme();

  return (
    <div
      css={[
        styles.pin(theme),
        !isNil(value) && styles.filledClass(theme),
        showValue && styles.charPinClass(theme),
        readOnly && styles.readOnlyClass(theme),
        current && styles.currentClass(theme),
      ]}
      data-testid="code-pin-placeholder"
      {...props}>
      {showValue && value}
    </div>
  );
};
